export const runCalculator = (runLength, design, project) => {
  // Calculate main posts based on max length between main posts
  let mainPosts;
  if (runLength <= design.maxLengthBetweenMainPosts) {
    mainPosts = 2;
  } else {
    mainPosts = Math.ceil(runLength / design.maxLengthBetweenMainPosts) + 1;
  }

  // Line posts calculation
  // Every run has 2 main posts at the ends
  // Line posts go in between based on postSpacing
  let linePosts = 0;
  if (runLength > design.postSpacing) {
    const totalPosts = Math.ceil(runLength / design.postSpacing) + 1;
    linePosts = totalPosts - 2;
  }

  let mainPostCaps = mainPosts;
  let linePostCaps = linePosts;

  let concreteBags =
    design.concretePerMainPost * mainPosts +
    design.concretePerLinePost * linePosts;

  let fenceTies =
    Math.ceil(runLength / design.fenceTiesEveryFt) +
    linePosts * design.tensionBandsPerMainPost;

  let mesh = runLength / design.meshLength;

  let tensionBands = (mainPosts - 1) * (design.tensionBandsPerMainPost * 2);

  let topRailAssemblys = (mainPosts - 1) * 2;
  let topRails = Math.ceil(runLength / design.topRailLength);
  let topRailSleeves = topRails;

  let tensionWire = runLength / design.tensionWireLength;

  // Tension bars: 2 per section between main posts
  let tensionBars = (mainPosts - 1) * 2;

  let centerMainPostBands = topRailAssemblys;

  let nutsAndBolts = tensionBands + centerMainPostBands;

  return {
    mainPosts,
    linePosts,
    mainPostCaps,
    linePostCaps,
    concreteBags,
    fenceTies,
    mesh,
    tensionBands,
    tensionBars,
    topRailAssemblys,
    topRails,
    topRailSleeves,
    tensionWire,
    centerMainPostBands,
    nutsAndBolts,
  };
};

export const calculateAllMaterials = (project, design) => {
  if (!project.lengths || typeof project.lengths !== "object") {
    return null;
  }

  // Initialize totals
  const totals = {
    mainPosts: 0,
    linePosts: 0,
    mainPostCaps: 0,
    linePostCaps: 0,
    concreteBags: 0,
    fenceTies: 0,
    mesh: 0,
    tensionBands: 0,
    tensionBars: 0,
    topRailAssemblys: 0,
    topRails: 0,
    topRailSleeves: 0,
    tensionWire: 0,
    centerMainPostBands: 0,
    nutsAndBolts: 0,
  };

  // Calculate total project length
  let totalLength = 0;

  // Calculate materials for each run and sum them up
  Object.values(project.lengths).forEach((run) => {
    if (run && run > 0) {
      totalLength += parseFloat(run);
      const runMaterials = runCalculator(run, design, project);

      Object.keys(totals).forEach((key) => {
        totals[key] += runMaterials[key];
      });
    }
  });

  // Add gate materials - convert to numbers since they come as strings from inputs
  const singleGates = Number(project.chainlinkSingleGates) || 0;
  const doubleGates = Number(project.chainlinkDoubleGates) || 0;
  const gateExtensions = Number(project.chainlinkGateExtensions) || 0;
  const gatePosts = Number(project.chainlinkGatePosts) || 0;

  const newMainPosts = gatePosts + totals.mainPosts;
  const newMainPostCaps = gatePosts + totals.mainPostCaps;

  return {
    ...totals,
    singleGates,
    doubleGates,
    gateExtensions,
    mainPosts: newMainPosts,
    mainPostCaps: newMainPostCaps,
    totalLength, // Add total project length for mesh price calculation
  };
};
